import React from 'react'
import HomeBanner from '../components/home-banner';
import VideoBanner from '../components/video-banner';
import AppraisalIntro from '../components/appraisal-intro';
import TeamRepeater from '../components/team-repeater';
import Introduction from '../components/introduction';
import ContactBody from '../components/contact-body';
import ContactOffices from '../components/contact-offices';
import Offices from '../components/offices';
import PMIntro from '../components/property-management-intro';
import PMInformation from '../components/property-management-information';
import PropertyBlocks from '../components/property-blocks';
import TeamMember from '../components/member';
import Video from '../components/video-page';
import LatestVideos from '../components/latest-videos';
import EventForm from '../components/event-form';
import TeamProperties from '../components/team-properties';
import PropertyLanding from '../components/property-landing';
import BasicPage from '../components/basic-page';
import ImageBanner from '../components/image-banner';
import SliderBanner from '../components/slider-banner';
import TitleContentButton from '../components/title-content-button';
import RentalAppraisalForm from "../components/rental-appraisal-form"
import BoughtBlocks from "../components/BoughtBlocks"
import AdvocacyBlock from "../components/advocacy-block"
import AdvocacyClients from "../components/advocacy-clients"
import AdvocacyFormBlock from "../components/advocacy-form-block"
import AdvocacyDownload from "../components/advocacy-download"
import Timeline from "../components/timeline"
import ImageContentContent from "../components/image-content-content"
import AgentHeader from "../components/agent-header"
import AgentStats from "../components/agent-stats"
import AgentBioMedia from "../components/agent-bio-media"
import Agent3Columns from "../components/agent-3-columns"
import AgentSalesStats from "../components/agent-sales-stats"
import AgentBanner from "../components/agent-banner"
import AgentListings from "../components/agent-listings"
import AgentContact from "../components/agent-contact"
import AgentBought from "../components/agent-bought"
import LifestyleIndex from "../components/lifestyle-index"
import TwoColumnContent from '../components/two-column-content'
import SuburbMap from '../components/suburb-map'
import SuburbContact from '../components/suburb-contact'
import Projects from '../components/projects'
import Content from '../components/content'
import PostImage from '../components/post-image'
import DoubleImage from '../components/double-image'
import NewsFeature from '../components/news-feature';
import ThankyouBlocks from "../components/thankyou-blocks";
import BasicFormBlock from '../components/basic-form-block';

const RenderBlock = (param, el, i, parentProps) => {

  if (!param) return null;

  el.key = i
  let block = {
    'page_Acf_ContentBlocks_HomeBanner': (el, i) => (<HomeBanner {...el} location={parentProps.location} />),
    'page_Acf_ContentBlocks_VideoBanner': (el, i) => (<VideoBanner {...el} location={parentProps.location} />),
    'page_Acf_ContentBlocks_Introduction': (el, i) => (<Introduction {...el} location={parentProps.location} />),
    'page_Acf_ContentBlocks_PropertyBlocks': (el, i) => (<PropertyBlocks {...el} />),
    'page_Acf_ContentBlocks_AppraisalIntro': (el, i) => (<AppraisalIntro {...el} />),
    'page_Acf_ContentBlocks_TeamRepeater': (el, i) => (<TeamRepeater {...el} />),
    'page_Acf_ContentBlocks_ContactBody': (el, i) => (<ContactBody {...el} />),
    'page_Acf_ContentBlocks_ContactOffices': (el, i) => (<ContactOffices {...el} />),
    'page_Acf_ContentBlocks_Offices': (el, i) => (<Offices {...el} />),
    'page_Acf_ContentBlocks_PropertyManagementIntro': (el, i) => (<PMIntro {...el} />),
    'page_Acf_ContentBlocks_PropertyManagementInformation': (el, i) => (<PMInformation {...el} />),
    'page_Acf_ContentBlocks_Member': (el, i) => (<TeamMember {...el} />),
    'page_Acf_ContentBlocks_VideoPage': (el, i) => (<Video {...el} />),
    'page_Acf_ContentBlocks_LatestVideos': (el, i) => (<LatestVideos {...el} />),
    'page_Acf_ContentBlocks_EventForm': (el, i) => (<EventForm {...el} />),
    'page_Acf_ContentBlocks_TeamProperties': (el, i) => (<TeamProperties {...el} />),
    'page_Acf_ContentBlocks_PropertyLanding': (el, i) => (<PropertyLanding {...el} />),
    'page_Acf_ContentBlocks_RecentlySold': (el, i) => (<RecentlySold {...el} />),
    'page_Acf_ContentBlocks_BasicPage': (el, i) => (<BasicPage {...el} />),
    'page_Acf_ContentBlocks_Projects': (el, i) => (<Projects {...el} />),
    'page_Acf_ContentBlocks_ImageBanner': (el, i) => (<ImageBanner {...el} />),
    'page_Acf_ContentBlocks_SliderBanner': (el, i) => (<SliderBanner {...el} />),
    'page_Acf_ContentBlocks_TitleContentButton': (el, i) => (<TitleContentButton {...el} />),
    'page_Acf_ContentBlocks_RentalAppraisalForm': (el, i) => (<RentalAppraisalForm {...el} />),
    'page_Acf_ContentBlocks_BoughtPropertyBlocks': (el, i) => (<BoughtBlocks {...el} />),
    'page_Acf_ContentBlocks_AdvocacyBlock': (el, i) => (<AdvocacyBlock {...el} />),
    'page_Acf_ContentBlocks_AdvocacyClients': (el, i) => (<AdvocacyClients {...el} />),
    'page_Acf_ContentBlocks_AdvocacyDownload': (el, i) => (<AdvocacyDownload {...el} />),
    'page_Acf_ContentBlocks_AdvocacyForm': (el, i) => (<AdvocacyFormBlock {...el} />),
    'page_Acf_ContentBlocks_Timeline': (el, i) => (<Timeline {...el} />),
    'page_Acf_ContentBlocks_ImageContentContent': (el, i) => (<ImageContentContent {...el} />),
    'page_Acf_ContentBlocks_NewsFeature': (el, i) => (<NewsFeature {...el} />),
    'page_Acf_ContentBlocks_ThankyouBlocks': (el, i) => (<ThankyouBlocks {...el} />),
    'page_Acf_ContentBlocks_BasicFormBlock': (el, i) => (<BasicFormBlock {...el} />),
    'agent_Acf_ContentBlocks_AgentHeader': (el, i) => (<AgentHeader {...el} team={parentProps.data.wpTeam} />),
    'agent_Acf_ContentBlocks_AgentStats': (el, i) => (<AgentStats {...el} />),
    'agent_Acf_ContentBlocks_AgentBioMedia': (el, i) => (<AgentBioMedia {...el} />),
    'agent_Acf_ContentBlocks_Agent3Columns': (el, i) => (<Agent3Columns {...el} />),
    'agent_Acf_ContentBlocks_AgentBanner': (el, i) => (<AgentBanner {...el} />),
    'agent_Acf_ContentBlocks_AgentSalesStats': (el, i) => (<AgentSalesStats {...el} team={parentProps.data.wpTeam} />),
    'agent_Acf_ContentBlocks_AgentListings': (el, i) => (<AgentListings {...el} current_properties={parentProps.data.current.edges} sold_properties={parentProps.data.sold.edges} />),
    'agent_Acf_ContentBlocks_AgentContact': (el, i) => (<AgentContact {...el} team={parentProps.data.wpTeam} />),
    'agent_Acf_ContentBlocks_AgentBought': (el, i) => (<AgentBought {...el} />),
    'suburb_Acf_ContentBlocks_ImageContentContent': (el, i) => (<ImageContentContent {...el} />),
    'suburb_Acf_ContentBlocks_ThreeColumnContent': (el, i) => (<Agent3Columns {...el} />),
    'suburb_Acf_ContentBlocks_TwoColumnContent': (el, i) => (<TwoColumnContent {...el} />),
    'suburb_Acf_ContentBlocks_ImageBanner': (el, i) => (<AgentBanner {...el} />),
    'suburb_Acf_ContentBlocks_Stats': (el, i) => (<AgentStats {...el} />),
    'suburb_Acf_ContentBlocks_SuburbMap': (el, i) => (<SuburbMap {...el} current={parentProps.data.current.edges} sold={parentProps.data.sold.edges} />),
    'suburb_Acf_ContentBlocks_SuburbProperties': (el, i) => (<AgentListings {...el} current_properties={parentProps.data.current.edges} sold_properties={parentProps.data.sold.edges} />),
    'suburb_Acf_ContentBlocks_LifestyleIndex': (el, i) => (<LifestyleIndex {...el} data={parentProps.data} />),
    'suburb_Acf_ContentBlocks_SuburbContact': (el, i) => (<SuburbContact {...el} office={parentProps.data.wpSuburb.acf.office?.length ? parentProps.data.wpSuburb.acf.office[0] : null} />),
    'post_Acf_Blocks_Content': (el, i) => (<Content {...el} />),
    'post_Acf_Blocks_Image': (el, i) => (<PostImage {...el} />),
    'post_Acf_Blocks_DoubleImage': (el, i) => (<DoubleImage {...el} />),
    
  }[param]

  if (!block) return null;

  return block(el, i)
}

export default RenderBlock
